export default "__VITE_ASSET__7vEXwfEN__"